// 项目类型 字段映射
export function projectTypeMapperName(type) {
  switch (type) {
    case "GC":
      return "工程建设";
      break;
    case "CG":
      return "政府采购";
      break;
    case "CQ":
      return "国有产权";
      break;
    case "GT":
      return "国土交易";
      break;
    case "QT":
      return "其他";
      break;
  }
}
export function typeMapperProjectNameDesc(type) {
  switch (type) {
    case "GC":
      return "招标项目名称";
      break;
    case "CG":
      return "采购项目名称";
      break;
    case "CQ":
      return "项目名称";
      break;
    case "GT":
      return "项目名称";
      break;
    case "QT":
      return "项目名称";
      break;
    default:
      return "项目名称";
      break;
  }
}
export function typeMapperProjectCodeDesc(type) {
  switch (type) {
    case "GC":
      return "招标项目编号";
      break;
    case "CG":
      return "采购项目编号";
      break;
    case "CQ":
      return "项目编号";
      break;
    case "GT":
      return "项目编号";
      break;
    case "QT":
      return "项目编号";
      break;
    default:
      return "项目编号";
      break;
  }
}
export function typeMapperBidNameDesc(type) {
  switch (type) {
    case "GC":
      return "标段名称";
      break;
    case "CG":
      return "包件名称";
      break;
    case "CQ":
      return "标的名称";
      break;
    case "GT":
      return "标的名称";
      break;
    case "QT":
      return "标的名称";
      break;
    default:
      return "标的名称";
      break;
  }
}
export function typeMapperBidCodeDesc(type) {
  switch (type) {
    case "GC":
      return "标段编号";
      break;
    case "CG":
      return "包件编号";
      break;
    case "CQ":
      return "标的编号";
      break;
    case "GT":
      return "标的编号";
      break;
    case "QT":
      return "所属项目编号";
      break;
    default:
      return "所属项目编号";
      break;
  }
}
export function typeMapperTraddingModDesc(type) {
  switch (type) {
    case "GC":
      return "招标方式";
      break;
    case "CG":
      return "采购方式";
      break;
    case "CQ":
      return "交易方式";
      break;
    case "GT":
      return "交易方式";
      break;
    case "QT":
      return "交易方式";
      break;
  }
}
export function typeMapperTraddingTimeDesc(type) {
  switch (type) {
    case "GC":
      return "开标时间";
      break;
    case "CG":
      return "开标时间";
      break;
    case "CQ":
      return "竞价开始时间";
      break;
    case "GT":
      return "竞价开始时间";
      break;
    case "QT":
      return "竞价开始时间";
      break;
    default:
      return "竞价开始时间";
      break;
  }
}

export function more99Filter(value) {
  if (value) {
    return Number(value) >= 99 ? "99+" : Number(value);
  } else {
    return 0;
  }
}

export function timeActiveFilter(value) {
  let temp = {
    1: "本月",
    2: "本年",
    3: "全部",
  };
  return temp[value];
}
